const { company } = window.env;

export const isGoal = () => {
  return company.id === 'k-goal';
};

export const hideFee = (studentId, assignData) => {
  if (!isGoal()) {
    return false;
  }

  return true;
};
